import React from 'react';
import BackButton from '@sharedComponents/BackButton/BackButton';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import { ThemedText, ThemedView } from '@app/theme';
import { PrivateStackParamList } from '@routes/types';

type CommonHeaderProps = {
  navigation: any;
  pageName: keyof PrivateStackParamList;
  showBackButton?: boolean;
  showNeedHelp?: boolean;
  rightComponent?: React.ReactNode;
  customHeight?: number;
  hideBottomBorder?: boolean;
  label?: string;
  customGoBackAction?: () => void;
}

const CommonHeader = ({ 
  navigation, 
  pageName, 
  showBackButton = true, 
  showNeedHelp = true,
  rightComponent,
  customHeight = 60,
  hideBottomBorder = false,
  label,
  customGoBackAction
}: CommonHeaderProps) => {
  return (
    <ThemedView
      flexDirection='row'
      justifyContent='space-between'
      bg={'bg-surface-primary'}
      paddingHorizontal='lg'
      borderBottomWidth={hideBottomBorder ? 0 : 1}
      borderBottomColor='border-primary'
      height={customHeight}
      alignItems='center'>
      <ThemedView flexDirection='row'>
          <ThemedView flexDirection='row' alignItems='center'>
            {showBackButton && (
              <BackButton pageName={pageName} navigation={navigation} customGoBackAction={customGoBackAction}/>
            )}
            <ThemedText variant='b3m' ml='sm'>{label}</ThemedText>
          </ThemedView>
      </ThemedView>
      {rightComponent || (showNeedHelp && <NeedHelp />)}
    </ThemedView>
  );
};

export default CommonHeader; 